import type { Language } from '../../../i18n/translations';
import { getList } from '../../../i18n/translations';

function pick(list: string[], rng: () => number, fallback: string): string {
    if (list.length === 0) return fallback;
    const index = Math.floor(rng() * list.length);
    return list[Math.max(0, Math.min(list.length - 1, index))] ?? fallback;
}

export function getRandomPersonName(lang: Language, rng: () => number): string {
    const first = getList(lang, 'names.people.first');
    const last = getList(lang, 'names.people.last');
    if (first.length === 0 || last.length === 0) return 'Anon';
    return `${pick(first, rng, 'Anon')} ${pick(last, rng, 'Anon')}`;
}
